import React from 'react';
import ReactDOM from 'react-dom';
import 'babel-polyfill';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import { BrowserRouter } from 'react-router-dom'
import thunkMiddleware from 'redux-thunk';
import { createLogger } from 'redux-logger';
import * as Sentry from '@sentry/browser';

import App from './components/pages/App';

import '../css/reset.scss';
import '../css/base.scss';
import '../css/font-faces.scss';

import rootReducer from './reducers';

// Enable hot module replacement
if (module.hot) {
    module.hot.accept();
}

Sentry.init({
    dsn: 'https://5e7db52bf4bc48c9a03d4ea88e22a89a@sentry.io/1302146',
    environment: window.config.environment
});
if (window.config.session_user) {
    Sentry.configureScope(scope => {
        scope.setUser({ id: window.config.session_user.id });
    });
}

ReactDOM.render(
    <BrowserRouter>
        <Provider store={createStore(rootReducer, applyMiddleware(thunkMiddleware, createLogger()))}>
            <App />
        </Provider>
    </BrowserRouter>,
    document.getElementById('root')
);